import { connect } from 'react-redux';
import { selectActiveVenue } from 'selectors/general';
import { selectSelectedClass, selectSelectedInstructor } from '../Ratings.selectors';
import ReviewsStatisticsHeader from './ReviewsStatisticsHeader';

const mapStateToProps = state => {
  const { venueName, venueSubtitle } = selectActiveVenue(state);
  const selectedVenueName = venueSubtitle ? `${venueName} (${venueSubtitle})` : venueName;
  const { name: selectedInstructorName } = selectSelectedInstructor(state);
  const { name: selectedClassName } = selectSelectedClass(state);

  return {
    selectedVenueName,
    selectedClassName,
    selectedInstructorName,
  };
};

export default connect(mapStateToProps)(ReviewsStatisticsHeader);
